module.exports = __webpack_public_path__ + "img/pudge.b68ecba3.png";